import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { ConfirmationDialogComponent } from './../confirmation-dialog.component';

@Injectable()
export class ConfirmationDialogService {

  constructor(private modalService: NgbModal) { }

  public confirm(
    title: string,
    message: string,
    subMessage: string = '',
    icon: string = '',
    information: string = '',
    btnOkText: string = 'Sim',
    btnCancelText: string = 'Não',
    dialogSize: 'sm'|'md'|'lg' = 'lg',
    complementaryMessage: string = '',
    dialogCentered: true | false = true
    ): Promise<boolean> {
    const modalRef = this.modalService.open(ConfirmationDialogComponent, { size: dialogSize, centered: dialogCentered });
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.btnOkText = btnOkText;
    modalRef.componentInstance.subMessage = subMessage;
    modalRef.componentInstance.complementaryMessage = complementaryMessage;
    modalRef.componentInstance.information = information;
    modalRef.componentInstance.icon = icon;
    modalRef.componentInstance.btnCancelText = btnCancelText;

    return modalRef.result;
  }

}
